import React, { useEffect } from 'react';

import { Box, Button, Loader, PaymentInfo, Typography } from 'components';
import { ArrowLeft } from 'iconsax-react';

import {
  useNavigate,
  useParams,
  useSelector,
  useTranslation,
} from 'third-party';

import {
  userOrganizationPaymentListUrl,
  userPaymentListUrl,
} from 'constants/url';

import { usePayment } from 'modules/payment';

import { appSelectors, paymentSelectors } from 'selectors';

export const PaymentDetail = () => {
  const { paymentId, organizationId } = useParams<{
    paymentId: string;
    organizationId: string;
  }>();
  const navigate = useNavigate();

  const { loadUserPayment } = usePayment();

  const paymentPending = useSelector(paymentSelectors.paymentPending);
  const payment = useSelector(paymentSelectors.payment);
  const user = useSelector(appSelectors.user);
  const { t } = useTranslation();

  useEffect(() => {
    if (paymentId) {
      loadUserPayment(paymentId);
    }
  }, [loadUserPayment, paymentId]);

  const handleBack = () => {
    navigate(
      organizationId
        ? userOrganizationPaymentListUrl(organizationId)
        : userPaymentListUrl(),
    );
  };

  if (paymentPending || !payment) {
    return <Loader />;
  }

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        margin="1rem"
      >
        <Typography variant="h2" color="text.primary">
          {t('userPayment.checkDetails')}
        </Typography>
        {user && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<ArrowLeft variant="TwoTone" size="24" />}
            onClick={handleBack}
          >
            {t('common.back')}
          </Button>
        )}
      </Box>
      <PaymentInfo payment={payment} />
    </Box>
  );
};
